<template>
  <v-main>
    <v-card>
      <v-container>
        <v-text-field
          :value="search"
          @change="onSearchChange"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>

        <v-row class="my-0 mt-2">
          <v-col class="py-0">
            <v-text-field label="Amount" type="number" :value="amount" @change="onAmountChange" />
          </v-col>
          <v-col class="py-0">
            <v-select
              :value="currentSource"
              :items="sources"
              label="Source"
              item-text="name"
              item-value="value"
              @change="onSourceChange"
            />
          </v-col>
          <v-col class="py-0">
            <v-text-field label="Pair start" type="number" v-model="start" />
          </v-col>
          <v-col class="py-0">
            <v-text-field label="Pair limit" type="number" v-model="limit" />
          </v-col>
        </v-row>

        <v-row class="my-0 mt-2">
          <v-col class="py-0">
            <ExSelect
              v-model="fromExchanges"
              :items="exchanges"
              label="From"
              @change="onExchangeChange"
            />
          </v-col>
          <v-col cols="1" class="py-0">
            <v-btn icon color="primary" style="margin: 10px" @click="swapExchanges">
              <v-icon>mdi-swap-horizontal</v-icon>
            </v-btn>
          </v-col>
          <v-col class="py-0">
            <ExSelect
              v-model="toExchanges"
              :items="exchanges"
              label="To"
              @change="onExchangeChange"
            />
          </v-col>
          <v-col class="py-0">
            <ExSelect
              v-model="selectedNetworks"
              :items="networkList"
              label="Networks"
              @change="onSelectedNetworksChange"
            />
          </v-col>
        </v-row>

        <v-row class="my-0 mb-4">
          <v-col class="py-0">
            <div>Number market: {{ numMarketPairs }}</div>
            <div>Loaded market: {{ coinsLength }}</div>
            <div>Loaded pairs: {{ pairsLength }}</div>
            <div>Latest updates: {{ latestUpdates }}</div>

            <v-flex class="d-flex flex-wrap">
              <v-checkbox
                class="mr-3 my-1"
                v-model="matchChains"
                label="Match chains"
                hide-details
                @change="onChainsChange"
              ></v-checkbox>
              <v-checkbox
                class="mr-3 my-1"
                v-model="depositEnable"
                label="Deposit"
                hide-details
                @change="onChainsChange"
              ></v-checkbox>
              <v-checkbox
                class="mr-3 my-1"
                v-model="withdrawEnable"
                label="Withdraw"
                hide-details
                @change="onChainsChange"
              ></v-checkbox>
              <v-checkbox
                class="mr-3 my-1"
                v-model="ignoreCoinsEnabled"
                label="ignore"
                hide-details
                @change="onIgnoreChange"
              ></v-checkbox>
              <v-checkbox
                class="mr-3 my-1"
                v-model="feesEnabled"
                label="Fees"
                hide-details
                @change="onCalcUpdate"
              ></v-checkbox>
              <v-checkbox
                class="mr-3 my-1"
                v-model="onlyMargin"
                label="Margin"
                hide-details
                @change="onMarginChange"
              ></v-checkbox>
              <v-checkbox
                class="mr-3 my-1"
                v-model="buyBids"
                label="bids for buy"
                hide-details
                @change="onCalcUpdate"
              ></v-checkbox>
              <v-checkbox
                class="mr-3 my-1"
                v-model="sellAsks"
                label="asks for sell"
                hide-details
                @change="onCalcUpdate"
              ></v-checkbox>
            </v-flex>
          </v-col>
        </v-row>
      </v-container>

      <v-data-table
        :headers="headers"
        :items="rates"
        item-key="key"
        :search="search"
        sort-by="maxFirstAmount"
        :items-per-page="15"
        sort-desc
        show-expand
        :loading="loading"
        :single-expand="false"
      >
        <!-- eslint-disable-next-line -->
        <template v-slot:item.symbol="{ item }">
          <a :href="item.url" target="_blank">{{ item.symbol }}</a>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.name="{ item }">
          <a :href="item.url2" target="_blank">{{ item.name }}</a>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.maxAmount="{ item }">
          {{ item.maxAmount.toFixed(2) }}$
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-flex style="max-width: 1200px" class="d-flex align-center">
              <v-text-field
                class="my-0 py-0"
                v-model="selectedSearch"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-btn class="mx-4" color="primary" @click="updateRate(item)" :loading="item.loading">
                update
              </v-btn>
            </v-flex>
            <v-data-table
              style="max-width: 1200px"
              :headers="selectedHeaders"
              :items="item.pairs"
              :items-per-page="-1"
              :search="selectedSearch"
              hide-default-footer
              item-key="marketId"
              sort-by="result.profit"
              sort-desc
              dense
            >
              <!-- eslint-disable-next-line -->
              <template v-slot:item.from.name="{ item }">
                <a :href="item.from.url" target="_blank">
                  {{ item.from.name }}
                </a>
                <sup v-if="item.from.margin">M</sup>
                <br />
                <v-chip
                  v-for="(c, i) in item.from.networks"
                  :key="i"
                  :color="c.withdrawEnable ? 'green' : 'red'"
                  small
                >
                  <template v-if="c.scan">
                    <a :href="c.scan.tokentxns" target="_blank" style="color: #000">{{
                      c.network
                    }}</a>
                  </template>
                  <template v-else>{{ c.network }}</template>
                </v-chip>
              </template>
              <!-- eslint-disable-next-line -->
              <template v-slot:item.to.name="{ item }">
                <a :href="item.to.url" target="_blank">
                  {{ item.to.name }}
                </a>
                <sup v-if="item.to.margin">M</sup>
                <br />
                <v-chip
                  v-for="(c, i) in item.to.networks"
                  :key="i"
                  :color="c.depositEnable ? 'green' : 'red'"
                  small
                >
                  <template v-if="c.scan">
                    <a :href="c.scan.tokentxns" target="_blank" style="color: #000">{{
                      c.network
                    }}</a>
                  </template>
                  <template v-else>{{ c.network }}</template>
                </v-chip>
              </template>
              <!-- eslint-disable-next-line -->
              <template v-slot:item.result.fromPrice="{ item }">
                <span style="font-size: 12px" v-if="item.result.askData">
                  {{ item.result.askData.start }}
                  <br />
                  {{ item.result.askData.end }}
                </span>
                <span v-else>
                  {{ item.result.fromPrice }}
                </span>
              </template>
              <!-- eslint-disable-next-line -->
              <template v-slot:item.result.toPrice="{ item }">
                <span style="font-size: 12px" v-if="item.result.bidData">
                  {{ item.result.bidData.start }}
                  <br />
                  {{ item.result.bidData.end }}
                </span>
                <span v-else>
                  {{ item.result.toPrice }}
                </span>
              </template>
              <!-- eslint-disable-next-line -->
              <template v-slot:item.result.fromAmount="{ item }">
                {{ item.result.fromAmount.toFixed(2) }}
                <br />
                <span style="font-size: 12px">{{ item.result.fromVolume.toFixed(2) }}</span>
              </template>
              <!-- eslint-disable-next-line -->
              <template v-slot:item.result.toAmount="{ item }">
                {{ item.result.toAmount.toFixed(2) }}
                <br />
                <span v-if="item.result.toVolume" style="font-size: 12px">{{
                  item.result.toVolume.toFixed(2)
                }}</span>
              </template>
              <!-- eslint-disable-next-line -->
              <template v-slot:item.result.fees="{ item }">
                <span style="font-size: 12px" v-if="item.result.fees.trading.from">
                  buy: {{ item.result.fees.trading.from.buyTakerFee * 100 }}%
                  <br />
                </span>
                <span style="font-size: 12px" v-if="item.result.fees.trading.to">
                  sell: {{ item.result.fees.trading.to.sellTakerFee * 100 }}%
                  <br />
                </span>
                <span style="font-size: 12px" v-if="item.result.fees.network">
                  {{ item.result.fees.volume }} - {{ item.result.fees.amount.toFixed(2) }}$ ({{
                    item.result.fees.network
                  }})
                </span>
                <span style="font-size: 12px" v-if="item.result.fees.withdrawPercent">
                  <br />
                  extra withdraw: {{ item.result.fees.withdrawPercent }}%
                </span>
                <span style="font-size: 12px" v-if="item.result.fees.depositFeePercent">
                  <br />
                  deposit - {{ item.result.fees.depositFeePercent * 100 }}%
                </span>
              </template>
              <!-- eslint-disable-next-line -->
              <template v-slot:item.result.profit="{ item }">
                {{ item.result.profit.toFixed(2) }}$ <br />
                <span style="font-size: 12px"> {{ item.result.percent.toFixed(2) }}%</span>
              </template>
            </v-data-table>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-main>
</template>

<script>
import axios from "axios";
import * as dayjs from "dayjs";
import ExSelect from "../components/ExSelect.vue";
import { getScanInfo, ignoreCoins } from "../../server/config.js";
import { NETWORKS } from "../../server/services/coins_chain/networks.js";
import { calculateBuySell } from "../../server/util/calc";
// import Worker from "../worker.js";

// const API_URL = "http://localhost:3000";
const API_URL = "https://rneratesapi.fly.dev";
const CRYPTOCURRENCY_URL = `${API_URL}/api/cryptorank/stream`;
const SIGNALS_URL = `${API_URL}/api/cryptorank/signals/stream`;
const MARGIN_URL = `${API_URL}/api/cryptorank/margins/stream`;
const MONITORINGS_URL = `${API_URL}/api/cryptorank/monitorings/stream`;
const CONFIG_URL = `${API_URL}/api/cryptorank/config`;
const UPDATE_ORDER_BOOK_URL = `${API_URL}/api/cryptorank/order-book/update`;
const NETWORKS_URL = `${API_URL}/api/networks`;

const CRYPTO_URLS = {
  1: CRYPTOCURRENCY_URL,
  2: MARGIN_URL,
  3: SIGNALS_URL,
  4: MONITORINGS_URL,
};

const STABLE_COINS = ["USDT", "USDC", "USD", "DAI"];

const exchanges = [
  {
    name: "Binance",
    value: "binance",
  },
  {
    name: "Kucoin",
    value: "kucoin",
  },
  {
    name: "Gate.io",
    value: "gateio",
  },
  {
    name: "MEXC",
    value: "mxc",
  },
  {
    name: "Bitget",
    value: "bitget",
  },
  {
    name: "Huobi",
    value: "huobi",
  },
  {
    name: "Bybit",
    value: "bybit",
  },
  {
    name: "WhiteBit",
    value: "whitebit",
  },
  {
    name: "OKX",
    value: "okx",
  },
  {
    name: "Probit",
    value: "probit",
  },
  {
    name: "Bitmart",
    value: "bitmart",
  },
  {
    name: "Bitrue",
    value: "bitrue",
  },
  {
    name: "XT",
    value: "xt",
  },
  {
    name: "ascendex",
    value: "ascendex",
  },
  {
    name: "Crypto.com",
    value: "crypto-com",
  },
  {
    name: "BingX",
    value: "bingx",
  },
  {
    name: "Poloniex",
    value: "poloniex",
  },
  {
    name: "Kraken",
    value: "kraken",
  },
  {
    name: "CoinEx",
    value: "coinex",
  },
  {
    name: "LBank",
    value: "lbank",
  },
  {
    name: "CoinW",
    value: "coinw",
  },
  {
    name: "Phemex",
    value: "phemex",
  },
  {
    name: "Coinbase",
    value: "coinbase",
  },
  {
    name: "Bitstamp",
    value: "bitstamp",
  },
  {
    name: "Bitmex",
    value: "bitmex",
  },
  {
    name: "Digifinex",
    value: "digifinex",
  },
  // {
  //   name: "Bitfinex",
  //   value: "bitfinex",
  // },
  // {
  //   name: "dex-tool-BSC",
  //   value: "dex-tool-bsc",
  // },
  // {
  //   name: "dex-tool-ETH",
  //   value: "dex-tool-ether",
  // },
  // {
  //   name: "dex-tool-SOLANA",
  //   value: "dex-tool-solana",
  // },
  // {
  //   name: "Cryptocom",
  //   value: "crypto-com",
  // },
  // {
  //   name: "Bitfinex",
  //   value: "bitfinex",
  // },
  // {
  //   name: "EXMO",
  //   value: "exmo",
  // },
  // {
  //   name: "Bkex",
  //   value: "bkex",
  // },
  // {
  //   name: "PancakeSwap",
  //   value: "pancake-swap",
  // },
];
const exchangeKeys = exchanges.map(({ value }) => value);

// function normalizaValue(value) {
//   return isFinite(value) ? value : 0;
// }

export default {
  name: "CryptoRankView",
  components: {
    ExSelect,
  },
  data: () => ({
    matchChains: true,
    depositEnable: true,
    withdrawEnable: true,
    buyBids: false,
    sellAsks: false,
    feesEnabled: true,
    ignoreCoinsEnabled: true,
    onlyMargin: false,
    rates: [],
    coinsLength: 0,
    pairsLength: 0,
    numMarketPairs: 0,
    loading: false,
    search: "",
    selectedSearch: "",
    latestUpdates: "",
    amount: 500,
    currentSource: 1,
    start: 1,
    limit: 30000,
    networkList: Object.values(NETWORKS).map((n) => ({ name: n, value: n })),
    selectedNetworks: [],
    fromExchanges: [
      "binance",
      "kucoin",
      "gateio",
      "mxc",
      "bitget",
      "huobi",
      "bybit",
      "whitebit",
      "okx",
      "probit",
      "bitmart",
      "bitforex",
      "bitrue",
      "xt",
      "ascendex",
      "bingx",
      "lbank",
      "coinw",
      "phemex",
      // "p2b",
    ],
    toExchanges: [
      "binance",
      "kucoin",
      "gateio",
      "mxc",
      "bitget",
      "huobi",
      "bybit",
      "whitebit",
      "okx",
      "probit",
      "bitmart",
      "bitforex",
      "bitrue",
      "xt",
      "ascendex",
      "bingx",
      "lbank",
      "coinw",
      "phemex",
      // "p2b",
    ],
    sources: [
      {
        name: "All",
        value: 1,
      },
      {
        name: "Margin",
        value: 2,
      },
      {
        name: "Signals",
        value: 3,
      },
      {
        name: "Monitorings",
        value: 4,
      },
    ],
    exchanges,
  }),

  async created() {
    // this.worker = new Worker();
    // this.worker.onmessage = (e) => {
    //   this.networks = e.data.payload.networks;
    //   this.resp = Object.freeze(e.data.payload.data);
    //   this.numMarketPairs = e.data.payload.count;
    // };
    this.loading = true;
    this.data = [];
    this.resp = {};
    this.networks = {};

    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }

    try {
      const savedExchanges = JSON.parse(localStorage.getItem("ex-cryptorank-exchanges") || "{}");

      this.amount = parseInt(localStorage.getItem("ex-cryptorank-amount")) || this.amount;

      this.fromExchanges = savedExchanges.fromExchanges || this.fromExchanges;
      this.toExchanges = savedExchanges.toExchanges || this.toExchanges;

      this.currentSource = parseInt(localStorage.getItem("ex-cryptorank-source")) || 1;
      this.limit = parseInt(localStorage.getItem("ex-cryptorank-limit")) || this.limit;

      if (this.currentSource == 2) {
        this.onlyMargin = true;
      }

      // this.worker.postMessage({ type: "created" });
      const { count, config } = await this.getConfig();
      this.numMarketPairs = count;
      console.log(new Date(config?.updates));
      this.latestUpdates = dayjs(config?.updates).format("DD.MM (HH:mm)");

      const [rates, networks] = await Promise.all([this.getCryptoRates(), this.getNetworks()]);

      this.networks = Object.freeze(networks);
      this.resp = Object.freeze(rates);

      this.loadCoins();
    } catch (err) {
      console.error(err);
    }

    this.loading = false;
  },

  computed: {
    headers() {
      return [
        {
          text: "Symbol",
          align: "start",
          value: "symbol",
        },
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        {
          text: "Max",
          value: "maxAmount",
        },
      ];
    },
    selectedHeaders() {
      return [
        { text: `from`, value: "from.name" },
        { text: `to`, value: "to.name" },
        { text: `fromPrice`, value: "result.fromPrice" },
        { text: `toPrice`, value: "result.toPrice" },
        { text: `fromAmount`, value: "result.fromAmount" },
        { text: `toAmount`, value: "result.toAmount" },
        { text: `fees`, value: "result.fees" },
        { text: `profit`, value: "result.profit" },
      ];
    },
  },

  methods: {
    async onSourceChange(value) {
      this.currentSource = value;
      localStorage.setItem("ex-cryptorank-source", this.currentSource);

      this.loading = true;
      this.resp = {};
      this.data = [];
      this.rates = [];
      this.coinsLength = 0;
      this.pairsLength = 0;
      this.numMarketPairs = 0;

      try {
        const { count, config } = await this.getConfig();
        this.latestUpdates = dayjs(config?.updates).format("DD.MM (HH:mm)");
        this.numMarketPairs = count;
        console.log(new Date(config?.updates));

        const rates = await this.getCryptoRates();

        this.resp = Object.freeze(rates);

        this.loadCoins();
      } catch (err) {
        console.error(err);
      }

      this.loading = false;
    },
    onSearchChange(value) {
      this.search = value;
    },
    onAmountChange(value) {
      this.amount = parseFloat(value);
      localStorage.setItem("ex-cryptorank-amount", this.amount);
      this.calculatePairs(true);
      this.updateRenderedData();
    },
    onIgnoreChange() {
      this.filterIgnoredCoins();
      this.calculatePairs();
      this.updateRenderedData();
    },
    onMarginChange() {
      this.filterMargin();
      this.calculatePairs();
      this.updateRenderedData();
    },
    onExchangeChange() {
      this.filterExchanges();
      this.calculatePairs();
      this.updateRenderedData();
    },
    onChainsChange() {
      this.handleNetworks();
      this.filterSelectedNetworks();
      this.calculatePairs();
      this.updateRenderedData();
    },
    onSelectedNetworksChange() {
      this.filterSelectedNetworks();
      this.calculatePairs();
      this.updateRenderedData();
    },
    swapExchanges() {
      const from = this.fromExchanges;
      const to = this.toExchanges;

      this.fromExchanges = to;
      this.toExchanges = from;
      localStorage.setItem(
        "ex-cryptorank-exchanges",
        JSON.stringify({
          fromExchanges: this.fromExchanges,
          toExchanges: this.toExchanges,
        })
      );

      this.filterExchanges();
      this.calculatePairs();
      this.updateRenderedData();
    },
    onCalcUpdate() {
      this.calculatePairs(true);
      this.updateRenderedData();
    },
    loadCoins() {
      this.preparePairs();
      this.applyAllFilters();
      this.calculatePairs();
      this.updateRenderedData();
    },
    applyAllFilters() {
      this.filterIgnoredCoins();
      this.filterMargin();
      this.filterExchanges();
      this.handleNetworks();
      this.filterSelectedNetworks();
    },
    preparePairs() {
      this.data = Object.freeze(
        Object.values(this.resp).map((curr) => {
          curr.pairs = this.getPairs(curr);
          curr.marketPairs = [];
          curr.url = `https://coinmarketcap.com/ru/currencies/${curr.key}`;
          curr.url2 = `https://cryptorank.io/ru/price/${curr.key}`;
          curr.disabled = false;
          curr.loading = false;

          return curr;
        })
      );
    },
    getPairs(coin) {
      const pairs = [];

      coin.marketPairs.forEach((fromPair) => {
        const buyAction = this.buyBids ? "bids" : "asks";
        if (
          STABLE_COINS.includes(fromPair.to) &&
          !!fromPair.orderBook?.[buyAction]?.[0] &&
          exchangeKeys.includes(fromPair.exchangeKey)
        ) {
          try {
            const fromNetworkList =
              fromPair.networks ||
              this.networks[fromPair.exchangeKey]?.[fromPair.from]?.networkList ||
              [];

            coin.marketPairs.forEach((toPair) => {
              const sellAction = this.sellAsks ? "asks" : "bids";
              if (
                STABLE_COINS.includes(toPair.to) &&
                !!toPair.orderBook?.[sellAction]?.[0] &&
                exchangeKeys.includes(toPair.exchangeKey) &&
                (toPair.exchangeKey !== fromPair.exchangeKey ||
                  (toPair.exchangeKey == fromPair.exchangeKey && toPair.to !== fromPair.to))
              ) {
                const toNetworkList =
                  toPair.networks ||
                  this.networks[toPair.exchangeKey]?.[toPair.from]?.networkList ||
                  [];

                pairs.push({
                  from: {
                    symbol: fromPair.symbol,
                    name: `${fromPair.exchangeName} - ${fromPair.symbol}`,
                    url: fromPair.url,
                    exchangeKey: fromPair.exchangeKey,
                    exchangeName: fromPair.exchangeName,
                    orderBook: fromPair.orderBook,
                    tradingFee: fromPair.tradingFee,
                    networks: fromNetworkList.map((n) => ({
                      ...n,
                      scan: getScanInfo(fromPair.exchangeKey, coin, n.network),
                    })),
                    margin: fromPair.margin,
                  },
                  to: {
                    symbol: toPair.symbol,
                    name: `${toPair.exchangeName} - ${toPair.symbol}`,
                    url: toPair.url,
                    exchangeKey: toPair.exchangeKey,
                    exchangeName: toPair.exchangeName,
                    orderBook: toPair.orderBook,
                    tradingFee: toPair.tradingFee,
                    networks: toNetworkList.map((n) => ({
                      ...n,
                      scan: getScanInfo(toPair.exchangeKey, coin, n.network),
                    })),
                    margin: toPair.margin,
                  },
                  disabled: {},
                });
              }
            });
          } catch (err) {
            console.log(err);
            console.log(fromPair.exchangeName, fromPair.from);
          }
        }
      });

      return pairs;
    },
    filterIgnoredCoins() {
      this.data.forEach((coin) => {
        coin.disabled = this.ignoreCoinsEnabled && ignoreCoins.includes(coin.key);
        this.filterIgnoredPairs(coin);
      });
    },
    filterIgnoredPairs(coin) {
      coin.pairs.forEach((pair) => {
        if (this.ignoreCoinsEnabled) {
          const fromKey = `${coin.key}-${pair.from.exchangeKey}`;
          const toKey = `${coin.key}-${pair.to.exchangeKey}`;
          pair.disabled.ignore = ignoreCoins.includes(fromKey) || ignoreCoins.includes(toKey);
        } else {
          pair.disabled.ignore = false;
        }
      });
    },
    filterMargin() {
      this.data.forEach((coin) => {
        coin.pairs.forEach((pair) => {
          pair.disabled.margin = this.onlyMargin && !pair.to.margin && !pair.from.margin;
        });
      });
    },
    filterExchanges() {
      this.data.forEach((coin) => {
        coin.pairs.forEach((pair) => {
          const from =
            this.fromExchanges.length && !this.fromExchanges.includes(pair.from.exchangeKey);
          const to = this.toExchanges.length && !this.toExchanges.includes(pair.to.exchangeKey);
          pair.disabled.exchange = from || to;
        });
      });
    },
    handleNetworks() {
      this.data.forEach((coin) => {
        coin.pairs.forEach((pair) => {
          pair.availableNetworks = pair.from.networks.reduce((res, fromNet) => {
            if (!this.withdrawEnable || fromNet.withdrawEnable) {
              const toNet = pair.to.networks.find((n) => n.network === fromNet.network);
              if (toNet && (!this.depositEnable || toNet?.depositEnable)) {
                res.push({
                  ...fromNet,
                  depositFeePercent: toNet.depositFeePercent,
                  depositConfirm: toNet.depositConfirm,
                });
              }
            }
            return res;
          }, []);

          pair.disabled.networks = this.matchChains && !pair.availableNetworks.length;
        });
      });
    },
    filterSelectedNetworks() {
      this.data.forEach((coin) => {
        coin.pairs.forEach((pair) => {
          let hasNetworks = true;

          if (this.selectedNetworks.length) {
            if (this.matchChains) {
              const availableList = pair.availableNetworks.map(({ network }) => network);
              hasNetworks = this.selectedNetworks.some((net) => availableList.includes(net));
            } else {
              const fromList = pair.from.networks.map(({ network }) => network);
              const toList = pair.to.networks.map(({ network }) => network);
              const allList = [...fromList, ...toList];
              hasNetworks = this.selectedNetworks.some((net) => allList.includes(net));
            }
          }

          pair.disabled.selectedNetworks = !hasNetworks;
        });
      });
    },
    calculatePairs(recalculate = false) {
      let counter = 0;
      this.data.forEach((coin) => {
        if (!coin.disabled) {
          counter = counter + this.calculate(coin, recalculate);
        }
      });
      console.log(`calculated pairs: ${counter}`);
    },
    calculate(coin, recalculate) {
      let counter = 0;
      coin.pairs.forEach((pair) => {
        if (!this.isDisabledPair(pair) && (!pair.calculated || recalculate)) {
          const buyAction = this.buyBids ? "bids" : "asks";
          const sellAction = this.sellAsks ? "asks" : "bids";
          const availableNetworks = pair.availableNetworks;

          const fees = {};
          if (availableNetworks[0]?.fees) {
            Object.assign(fees, availableNetworks[0]?.fees);
          } else {
            fees.volume = availableNetworks[0]?.withdrawalFee || 0;
            fees.network = availableNetworks[0]?.network || "";
            fees.withdrawPercent = availableNetworks[0]?.withdrawPercent;
            // fees.amount = fees.volume * askData.avg;
          }
          fees.depositFeePercent = availableNetworks[0]?.depositFeePercent || 0;
          fees.depositConfirm = availableNetworks[0]?.depositConfirm || 0;

          fees.trading = {
            from: pair.from.tradingFee,
            to: pair.to.tradingFee,
          };

          if (fees.depositFeePercent) {
            console.log(
              `dep fee: ${pair.to.exchangeName} - ${pair.to.symbol}: ${
                fees.depositFeePercent * 100
              }%`
            );
          }

          let { buy, sell, feeAmount, profit } = calculateBuySell(
            { buyAction, sellAction, fees, max: this.amount, feesEnabled: this.feesEnabled },
            pair.from,
            pair.to
          );
          const askPrice = buy.amount / buy.volume;
          const bidPrice = sell.amount / sell.volume;

          if (availableNetworks[0]?.fees) {
            profit -= fees.amount;
          } else {
            fees.amount = feeAmount;
          }

          const percent = (profit / buy.amount) * 100;

          pair.calculated = true;
          pair.result = {
            fromVolume: buy.volume,
            toVolume: sell.volume,
            fromPrice: askPrice,
            toPrice: bidPrice,
            fromAmount: buy.amount,
            toAmount: sell.amount,
            askData: buy,
            bidData: sell,
            fees,
            profit,
            percent,
          };
          counter++;
        } else if (recalculate) {
          pair.calculated = false;
          pair.result = {};
        }
      });
      return counter;
    },
    updateRenderedData() {
      this.rates = Object.freeze(
        this.data
          .filter((coin) => !coin.disabled)
          .map((coin) => {
            const pairs = coin.pairs.filter((pair) => !this.isDisabledPair(pair));

            const maxAmount = pairs.length
              ? Math.max(...pairs.map(({ result = {} }) => result.profit || -Infinity))
              : 0;

            if (pairs.length && !coin.maxFirstAmount) {
              coin.maxFirstAmount = maxAmount;
            }

            coin.maxAmount = maxAmount;

            return {
              ...coin,
              pairs,
            };
          })
          .filter((coin) => coin.pairs.length)
      );
      this.coinsLength = this.rates.length;
      this.pairsLength = this.rates.reduce((res, coin) => {
        return res + coin.pairs.length;
      }, 0);
    },
    isDisabledPair(pair) {
      return !!Object.values(pair.disabled).some((val) => val);
    },
    async updateRate(item) {
      item.loading = true;
      try {
        const body = Object.assign({}, item);
        delete body.marketPairs;
        delete body.pairs;
        const resp = await this.updateOrderBook(body);
        const coin = this.resp[resp.key];
        coin.pairs = [];
        coin.marketPairs = resp.marketPairs;
        coin.pairs = this.getPairs(coin);
        coin.marketPairs = [];
        this.applyAllFilters();
        this.calculate(coin);
        this.updateRenderedData();
      } catch (err) {
        console.error(err);
      }

      item.loading = false;
    },
    async getCryptoRates() {
      const url = CRYPTO_URLS[this.currentSource];
      const { data = [] } = await axios.get(url);

      return Object.fromEntries(data.map((r) => [r.key, r.data]));
    },
    async updateOrderBook(body) {
      const responce = await axios.post(UPDATE_ORDER_BOOK_URL, body);

      return responce.data;
    },
    async getNetworks() {
      const responce = await axios.get(NETWORKS_URL);

      return responce.data;
    },
    async getConfig() {
      const responce = await axios.get(CONFIG_URL);

      return responce.data;
    },
  },
};
</script>
